module.exports = __webpack_public_path__ + "img/dod-image-logo.c9670442.png";